// extracted by mini-css-extract-plugin
module.exports = {"field":"CustomPricePointTab_field__2Ei_p","text":"CustomPricePointTab_text__1gdcT","input":"CustomPricePointTab_input__2nraR","button":"CustomPricePointTab_button__3JXMK"};